import PopularEventsCarousel from './PopularEventsCarousel';

export default PopularEventsCarousel;
